import useFetchApi, { FetchingStatus } from 'hooks/useFetchApi/useFetchApi'
import { BrandStatusContract } from 'models'
import { useCallback, useMemo } from 'react'
import { useDispatch } from 'react-redux'
import brandService from 'Services/brand.service'
import { showErrorMessage } from 'store/actions/ui.action'

const useLocationBrands = () => {
    const dispatch = useDispatch()
    const [
        brandStatus = [] as BrandStatusContract[],
        fetchBrandStatus,
        status,
        ,
        ,
        setBrandStatus,
    ] = useFetchApi(brandService.getLocationBrandsStatus)
    const fetchBrandsDispatch = useCallback(() => {
        fetchBrandStatus(true)
    }, [fetchBrandStatus])

    const loading = status !== FetchingStatus.SUCCESS

    const activeBrandCount = useMemo(() => {
        return brandStatus.filter((a) => a.isActive).length
    }, [brandStatus])

    const handleOnToggleSwitch = useCallback(
        async (key: string, toggleItem: BrandStatusContract) => {
            const id = toggleItem.brandID!!
            const newValue: boolean = !(toggleItem as any)[key]
            if (activeBrandCount === 1 && !newValue)
                dispatch(
                    showErrorMessage({
                        message: 'Require at least 1 brand to active.',
                    }),
                )
            else {
                await brandService.updateLocationBrandsStatus(id, newValue)
                setBrandStatus((prev) =>
                    prev?.map((e) => {
                        if (e.brandID === id)
                            return {
                                ...e,
                                isActive: newValue,
                            }
                        return e
                    }),
                )
            }
        },
        [activeBrandCount, dispatch, setBrandStatus],
    )
    const handleOnDeleteBrands = useCallback(
        async (brands: BrandStatusContract[]) => {
            if (
                activeBrandCount - brands.filter((b) => b.isActive).length ===
                0
            )
                dispatch(
                    showErrorMessage({
                        message: 'Require at least 1 brand to active.',
                    }),
                )
            else {
                const brandIDs = brands.map((a) => a.brandID!)
                await brandService.deleteLocationBrands(brandIDs)
                fetchBrandStatus()
            }
        },
        [activeBrandCount, dispatch, fetchBrandStatus],
    )

    return {
        loading,
        brands: brandStatus,
        fetchBrandsDispatch,
        handleOnToggleSwitch,
        handleOnDeleteBrands,
        activeBrandCount,
    }
}

export default useLocationBrands
